import { useTranslation } from 'react-i18next';
import { useFlightRooms } from '@connect-x-app/hybrid-state';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import { useApp } from '@connect-x-app/web-state';
import { EmptyState } from '@connect-x-app/web-ui';

import './ChatWrapperEmpty.scss';

export const ChatWrapperEmpty = () => {
  const { t } = useTranslation();
  const { isCurrentlySelectedTabEmpty, isEmptySearch } = useApp();
  const { selectedFlightRoomTab } = useFlightRooms();

  const renderText = () => {
    if (isEmptySearch) {
      return null;
    }
    if (!isCurrentlySelectedTabEmpty) {
      return <Text className="empty-body-text">{t('FLIGHTROOMS.SELECT_TO_SEND')}</Text>;
    } else {
      return (
        <>
          <Text as="h1" className="empty-title" color={COLORS.zulu.$08} size="LG" weight="bold">
            {t('FLIGHTROOMS.EMPTY_1')}
          </Text>
          <Text className="empty-body-text" color={COLORS.zulu.$08} size="SM">
            {t('FLIGHTROOMS.EMPTY_2')}
          </Text>
        </>
      );
    }
  };

  return <EmptyState className={selectedFlightRoomTab ?? ''}>{renderText()}</EmptyState>;
};
